import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { ECMSType, ECMSPage, EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

interface IStorePromises {
	fetchPageSectionsPromise: Promise<IHomePageSectionModel[]> | null
}

export interface IPageSectionsStoreState {
	pageSections: IHomePageSectionModel[] | null
	fetchedLang: string | null
}

export interface IPageSectionsStore {
	readonly state: IPageSectionsStoreState
	fetchPageSections: () => Promise<IHomePageSectionModel[] | undefined>
	getPageSections: ComputedRef<IHomePageSectionModel[] | null>
	pageMetaObject: ComputedRef<IHomePageSectionModel | undefined>
}

export const usePageSectionsStore = defineStore('pageSectionsStore', (): IPageSectionsStore => {
	const { getLocaleLang } = usei18nService()

	const _state = reactive<IPageSectionsStoreState>({
		pageSections: null,
		fetchedLang: null,
	})

	const promises: IStorePromises = {
		fetchPageSectionsPromise: null,
	}

	const fetchPageSections = async () => {
		try {
			const currentLang = getLocaleLang()

			if (_state.pageSections && _state.fetchedLang === currentLang) {
				return _state.pageSections
			}

			if (_state.fetchedLang !== currentLang) {
				promises.fetchPageSectionsPromise = null
			}

			if (promises.fetchPageSectionsPromise) {
				return promises.fetchPageSectionsPromise
			}

			promises.fetchPageSectionsPromise = (async () => {
				const fetchedPageSections = await ApiService.fetchPageSections(ECMSType.SUBPAGE, ECMSPage.HOME, currentLang, {
					skipSSRPayload: true,
				})
				// pageSections.value = response.data
				// pageMetaObject.value = response.data
				// 	?.find((section) => section.name === EPageSectionType.META)
				// 	?.translations.find((translation) => translation.language === locale.value)?.content[0]

				if (fetchedPageSections) {
					_state.pageSections = fetchedPageSections.data
					_state.fetchedLang = currentLang
				} else {
					_state.pageSections = null
					_state.fetchedLang = null
				}

				return _state.pageSections as IHomePageSectionModel[]
			})()

			return await promises.fetchPageSectionsPromise
		} catch (error) {
			logger.log(error)
		}
	}

	const getPageSections = computed(() => _state.pageSections)

	const pageMetaObject = computed(() => {
		return _state.pageSections
			?.find((section) => section.name === EPageSectionType.META)
			?.translations.find((translation) => translation.language === getLocaleLang())?.content[0]
	})
	return {
		state: _state,
		fetchPageSections,
		getPageSections,
		pageMetaObject,
	}
})
